import '@fontsource-variable/atkinson-hyperlegible-next';
import './styles/tokens.css';
import './styles/base.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { loadOfflineCopy } from './lib/offline';
import { startPwa } from './lib/pwa';

startPwa();
// The offline copy must be in memory before the first request, so the app can open without a connection.
void loadOfflineCopy().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
